import React, { Fragment, useContext } from "react";
import "./styles.css";
import receipt_bottom from "./../../../../assets/images/receipt_bottom_pattern.png";
import { LanguageContext } from "../../../../context/LanguageContext";
import { SuccessPayment } from "../../../../assets/icons/icon";
import { ParagraphText } from "../../../../Libraries";
import { Box, capitalize } from "@mui/material";
import { formatNum } from "../../../../oscar-pos-core/constants";

const Receipt = React.forwardRef(
  (
    {
      subTitle = "",
      subTitle2 = "",
      amount = 0,
      items = [],
      commissionPrice = 0,
    },
    ref
  ) => {
    const [I18n] = useContext(LanguageContext);

    return (
      <div className="reciptPageConatiner">
        <div className="recipt-content">
          <div ref={ref} className="receipt-container">
            <div className="receipt-inner">
              <div className="wallet-receipt-header">
                <SuccessPayment width={35} height={35} />
                <Box mb={1} />
                <ParagraphText className={"fontWeight500 fontSize16"}>
                  {I18n.transaction_successful}
                </ParagraphText>
                <div className="marginBottom6" />
                <ParagraphText
                  align="center"
                  className="fontSize10 foundationInk300"
                >
                  {subTitle}
                </ParagraphText>
                <ParagraphText
                  align="center"
                  className="fontSize10 foundationInk300"
                >
                  {subTitle2}
                </ParagraphText>
                <div className="marginBottom8" />
                <ParagraphText
                  className={
                    "textCenter newFontColor fontSize24 fontWeight600"
                  }
                >
                  PKR {formatNum(amount)}
                </ParagraphText>
              </div>
              <div className="cut-shape-view">
                <div className="dash-line-view">
                  {[...Array(15)].map((item, index) => {
                    return <div className="dash-line" key={index} />;
                  })}
                </div>
              </div>

              {items.map((item, i) => (
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  marginTop={i !== 0 ? "20px" : "0px"}
                >
                  <ParagraphText className={"foundationInk300 fontSize14"}>
                    {item.label}
                  </ParagraphText>
                  <ParagraphText
                    className={"blue800Color fontSize14 d-flex textRight"}
                  >
                    {item.image ? (
                      <img
                        width={17}
                        height={17}
                        src={item.image}
                        alt={item.image}
                      />
                    ) : null}{" "}
                    {item.value}
                    {item.status && (
                      <span
                        className={`statusTag fontSize12 ${
                          item.status === "paid" ? "paidTag" : "unPaidTag"
                        }`}
                      >
                        {capitalize(item.status === "paid" ? "Paid" : "Unpaid")}
                      </span>
                    )}
                  </ParagraphText>
                </Box>
              ))}

              
              <div className="receipt-bottom">
                <img src={receipt_bottom} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default Receipt;
